<template>
    <div>
        <div class="query row-flex row-between-center">
            <div
                class="query-time row-flex row-center-center"
                @click="selectTime"
            >
                <div class="time">{{ time }}</div>
                <img src="../../assets/newImg/up_down.png" alt="" />
            </div>
            <div
                class="query-btn text-color border-color row-flex row-center-center" @click="selectMonth"
            >
                查询
            </div>
        </div>
        <div style="height:70px"></div>
        <div class="int-list" ref="container">
            <div
                class="li row-flex row-between-center"
                v-for="(item, index) in incomeMoney"
                :key="index"
            >
                <div class="li-left">
                    <div class="li-left-top">{{ item.title }}</div>
                    <div class="li-left-time">{{ item.addtime_text }}</div>
                </div>
                <div class="li-right">{{ item.number }}</div>
            </div>
        </div>
        <div class="no-show" v-if="incomeMoney.length == 0 && loadend">
            <img src="../../assets/newImg/no_show.png" alt="" />
        </div>
        <div class="loading-more" >
            {{incomeMoney.length == 0 ?'暂无相关数据':'暂无更多了'}}
        </div>
        <van-popup v-model="show" position="bottom" :style="{ height: '40%' }">
            <van-datetime-picker
                v-model="currentDate"
                type="year-month"
                :formatter="formatter"
                @confirm="confirm"
                @cancel="cancel"
            />
        </van-popup>
    </div>
</template>
<style lang="scss" scoped>
.query {
    margin: 0 10px 13px 10px;
    height: 61px;
    background: #ffffff;
    border-radius: 10px;
    box-shadow: 0px 1px 15px 0px rgba(157, 157, 157, 0.2);
    padding: 0 14px;
    position: fixed;
    left: 0;
    right: 0;
    .query-btn {
        width: 93px;
        height: 30px;
        font-size: 15px;
        border-radius: 4px;
        font-weight: 600;
    }
    .query-time {
        width: 222px;
        height: 30px;
        background: #f8f8f8;
        border-radius: 4px;
        .time {
            font-size: 15px;
            color: #666666;
        }
        img {
            width: 10px;
            height: 13px;
            margin-left: 6px;
        }
    }
}
.int-list {
    margin: 0 10px;
    .li {
        height: 70px;
        background: #ffffff;
        border-radius: 5px;
        box-shadow: 0px 1px 10px 0px rgba(153, 153, 153, 0.09);
        margin-bottom: 5px;
        .li-left {
            margin-left: 12px;
            .li-left-top {
                font-size: 16px;
                color: #333333;
            }
            .li-left-time {
                color: #999999;
                font-size: 14px;
                padding-top: 6px;
            }
        }
        .li-right {
            padding-right: 10px;
            font-size: 16px;
            font-weight: 600;
        }
    }
}
</style>
<script>
import Vue from "vue";
import { DatetimePicker, Popup } from "vant";
import { intergralList } from "@api/user";
Vue.use(DatetimePicker);
Vue.use(Popup);
export default {
    name: "intDetail",
    data() {
        return {
            show: false,
            currentDate: new Date(),
            time: "",
            incomeMoney: [],
            loadend:false,
            loading:false,
            page:1,
            limit:10,
        };
    },
    methods: {
        formatter(type, val) {
            if (type === "year") {
                return `${val}年`;
            } else if (type === "month") {
                return `${val}月`;
            }
            return val;
        },
        /**选择时间 */
        selectTime() {
            this.show = true;
        },
        confirm(e) {
            this.time = this.timestampToTime(e.getTime());
            console.log(this.time);
            this.show = false;
        },
        cancel() {
            this.show = false;
        },
        /**查询 */
        selectMonth() {
            this.page=1;
            this.loadend=false;
            this.loading=false
            this.incomeMoney=[];
            this.comeMoney();
        },
        /**时间戳转时间 */
        timestampToTime(timestamp) {
            var date = new Date(timestamp);
            var Y = date.getFullYear() + "-";
            var M =
                date.getMonth() + 1 < 10
                    ? "0" + (date.getMonth() + 1)
                    : date.getMonth() + 1;
            return Y + M;
        },
        /**收入 */
        comeMoney() {
            let date = new Date().getTime();
            let that = this;
            if (that.loading) return; 
            if (that.loadend) return; 
            that.loading = true;
            let params = {
                month: this.time == "" ? this.timestampToTime(date) : this.time,
                page:that.page,
                limit:that.limit
            };
            intergralList(params).then((res) => {
                this.time = params.month;
                that.loading = false;
                that.incomeMoney.push.apply(that.incomeMoney, res.data);
                that.loadend = res.data.length < that.limit;
                that.page = that.page + 1;
            });
        },
    },
    mounted() {
        this.comeMoney();
        this.$scroll(this.$refs.container, () => {
            !this.loading && this.comeMoney();
        });
    },
};
</script>
